<template>
  <div>
    <BaseTitle :title="$t('content.view_anal_student')" />
    <file-viewer :data="preview" v-model="dialogPreview" @onHide="hidePreview" />
    <!-- data content -->
    <div id="hanyainisaja">
      <!-- class performance -->
      <v-row>
        <v-col md="12">
          <v-card class="pa-8"
            ><div class="d-flex align-center justify-space-between">
              <div class="app-section-title mb-5">
                {{ $t('content.class_performance') }}
                <br />
              </div>
              <div>
                <v-progress-circular class="text-center" v-if="loadingLoad === true" indeterminate color="primary" />
              </div>
              <div class="mb-5">
                <v-btn color="primary" class="btn-primary-custom mr-3" :loading="loadingExport" @click="downloadPdf()">{{
                  $t('content.export_pdf')
                }}</v-btn>
                <br />
              </div>
            </div>
            <div class="class-perform-rank  mb-5 pa-5">
              <div class="d-flex align-center justify-space-between">
                <div>
                  <strong style="color :#6D6D6D;">{{ $t('content.ranking_overall') }}</strong>
                </div>
                <div>
                  <strong style="color:#00bf63;">{{ form.classPerformance.studentFrom }} </strong>
                  <span style="from-student">{{ $t('form.from') }} {{ form.classPerformance.totalStudent }} {{ $t('content.student') }} </span>
                </div>
              </div>
            </div>
            <v-divider class="mt-5 mb-5" />
            <div class="d-flex align-center justify-space-between">
              <div class="app-section-title mb-5">
                {{ $t('content.average_score') }}
                <br />
              </div>
              <div class="app-section-title" style="color:#00bf63;">{{ form.classPerformance.averageScore }} %</div>
            </div>
            <div id="chart" class="d-flex justify-center">
              <apexchart type="line" height="350" width="210%" :options="chartOptionsClassPerform" :series="seriesClassPerform" />
            </div>
          </v-card>
        </v-col>
      </v-row>

      <!-- attendance -->
      <v-row>
        <v-col md="12">
          <v-card class="pa-8">
            <div class="d-flex justify-space-between">
              <div class="app-section-title mb-5">
                {{ $t('form.attendance') }}
                <br />
              </div>
            </div>
            <v-row>
              <v-col md="6">
                <div class="app-section-title mb-5" v-if="form.attendance.totalSession > 1">
                  <apexchart type="donut" height="150%" width="100%" :options="chartOptionsAttendance" :series="seriesAttendance" />
                  <!-- <apexchart type="bar" height="350" :options="chartOptionsAttendance" :series="seriesAttendance" /> -->
                </div>
                <div v-if="form.attendance.totalSession === 0">
                  <template>
                    <div class="succ">
                      <div class="succ-content">
                        <svg-icon icon="ic-nodata-mini" class="succ-featured" width="130" height="100" />
                        <h1 class="succ-heading">{{ $t('content.chart_not_available') }}</h1>
                      </div>
                    </div>
                  </template>
                </div>
              </v-col>
              <v-col md="6">
                <div v-for="(data, index) in form.attendance.data" :key="index" class="mb-5">
                  <div class="d-flex justify-space-between">
                    <div class=" mb-5">
                      <strong style="color :#6D6D6D;" v-if="index === 0">{{ $t('content.attendance_item.present') }}</strong>
                      <strong style="color :#6D6D6D;" v-if="index === 1">{{ $t('content.attendance_item.late') }}</strong>
                      <strong style="color :#6D6D6D;" v-if="index === 2">{{ $t('content.attendance_item.excuse_leave') }}</strong>
                      <strong style="color :#6D6D6D;" v-if="index === 3">{{ $t('content.attendance_item.unexcuse_leave') }}</strong>
                      <strong style="color :#6D6D6D;" v-if="index === 4">{{ $t('content.attendance_item.sick') }}</strong>
                    </div>
                    <div class="app-section-title mb-5">
                      {{ data }}
                    </div>
                  </div>
                  <v-progress-linear
                    v-if="index === 0"
                    style="
            border-radius: 8px;"
                    color="#0177FB"
                    :value="data"
                    height="10"
                  />
                  <v-progress-linear
                    v-if="index === 1"
                    style="
            border-radius: 8px;"
                    color="#40DCA7"
                    :value="data"
                    height="10"
                  />
                  <v-progress-linear
                    v-if="index === 2"
                    style="
            border-radius: 8px;"
                    color="#FF9743"
                    :value="data"
                    height="10"
                  />
                  <v-progress-linear
                    v-if="index === 3"
                    style="
            border-radius: 8px;"
                    color="rgb(255, 69, 96)"
                    :value="data"
                    height="10"
                  />
                  <v-progress-linear
                    v-if="index === 4"
                    style="
            border-radius: 8px;"
                    color="rgb(119, 93, 208)"
                    :value="data"
                    height="10"
                  />
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <!-- pentagon report -->
      <v-row align="stretch">
        <v-col md="7">
          <v-card class="pa-8 " height="400">
            <div class="d-flex justify-space-between">
              <div class="app-section-title mb-5">
                {{ $t('content.pentagon_report') }}
                <br />
              </div>
            </div>
            <div>
              <div id="chart" v-if="form.pentagon.data.length >= 3">
                <apexchart type="radar" height="350" :options="chartOptionsPentagon" :series="seriesPentagon" />
              </div>
              <div v-if="form.pentagon.data.length <= 2">
                <template>
                  <div class="succ">
                    <div class="succ-content">
                      <svg-icon icon="ic-nodata-mini" class="succ-featured" width="130" height="100" />
                      <h1 class="succ-heading">{{ $t('content.chart_not_available') }}</h1>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </v-card>
        </v-col>
        <v-col md="5">
          <v-card class="pa-8 " height="400">
            <div class="d-flex  justify-space-between">
              <div class="app-section-title mb-5">
                {{ $t('content.top_3_course') }}
                <br />
              </div>
            </div>
            <div class="class-perform-rank  mb-5 pa-5" v-for="(data, index) in form.pentagon.topThree" :key="index">
              <div class="d-flex align-center justify-space-between">
                <div>
                  <strong style="color :#6D6D6D;">{{ data.courseName }}</strong>
                </div>
                <div>
                  <strong style="color:#00bf63;">{{ data.score }} </strong>
                </div>
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </div>

    <!-- export content -->
    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="false"
      :preview-modal="false"
      filename="agung"
      :paginate-elements-by-height="1100"
      :pdf-quality="2"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="800px"
      :manual-pagination="false"
      :html-to-pdf-options="htmlToPdfOptions"
      @beforeDownload="beforeDownload($event)"
      ref="html2Pdf"
    >
      <section class="pdf-content table-content" slot="pdf-content">
        <!-- class performance -->
        <section class="table-container">
          <table border="0" width="100%">
            <tr>
              <td>
                Nama Sekolah :<span style="color :#6D6D6D;"> {{ form.schoolName ? form.schoolName : '-' }} </span>
              </td>
              <td>
                Kelas : <span style="color :#6D6D6D;"> {{ form.classroomName ? form.classroomName : '-' }}</span>
              </td>
            </tr>
            <br />
            <tr>
              <td>
                Nama : <span style="color :#6D6D6D;"> {{ form.fullName ? form.fullName : '-' }}</span>
              </td>
              <td>
                Tahun Ajaran : <span style="color :#6D6D6D;"> {{ form.yearPeriode ? form.yearPeriode : '-' }}</span>
              </td>
            </tr>
            <br />
            <tr>
              <td>
                NIS : <span style="color :#6D6D6D;"> {{ form.identityNumber ? form.identityNumber : '-' }}</span>
              </td>
            </tr>
          </table>
        </section>
        <section class="line">
          <hr width="100%" />
        </section>
        <section
          class="line"
          style="
          margin-top:20px;
          text-align: center"
        >
          <span style="color :#6D6D6D; font-size:20px;">Analytical Student</span>
        </section>
        <section
          class="line"
          style="
          margin-top:40px;"
        >
          <h4 style="color :#6D6D6D; margin-bottom:30px;">A.Class Performance</h4>

          <div class="class-perform-rank">
            <div class="row">
              <div class="left" style="margin-top:27px">
                <strong style="color :#6D6D6D"> {{ $t('content.ranking_overall') }}</strong>
              </div>
              <div class="right" style="margin-top:27px">
                <div>
                  <strong style="color:#00bf63;">{{ form.classPerformance.studentFrom }} </strong>
                  <span style="from-student">From {{ form.classPerformance.totalStudent }} student </span>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="chart-container" style="padding: 40px;">
          <div class="row">
            <div class="left">Average Score</div>
            <div class="right">
              <div class="app-section-title " style="color:#00bf63;">{{ form.classPerformance.averageScore }} %</div>
              Grade
            </div>
          </div>
          <apexchart type="line" height="100%" width="100%" :options="chartOptionsClassPerform" :series="seriesClassPerform" />
        </section>

        <div class="html2pdf__page-break" />

        <!-- attendance -->
        <section class="chart-container" style="padding:40px;">
          <h4 style="color :#6D6D6D;margin-bottom:50px;">B.Attendance Pie Chart And Bar Chart</h4>
          <template v-if="form.attendance.totalSession > 1">
            <apexchart type="donut" height="100%" width="100%" :options="chartOptionsAttendance" :series="seriesAttendance" />
          </template>
          <div v-if="form.attendance.totalSession === 0">
            <template>
              <div class="succ">
                <div class="succ-content">
                  <svg-icon icon="ic-nodata-mini" class="succ-featured" width="130" height="100" />
                  <h1 class="succ-heading">{{ $t('content.chart_not_available') }}</h1>
                </div>
              </div>
            </template>
          </div>
        </section>
        <section class="line">
          <hr width="100%" style="margin-top:100px;" />
          <div v-for="(data, index) in form.attendance.data" :key="index" class="mb-5">
            <div class="row">
              <div class="left" style="margin-top:27px">
                <strong style="color :#6D6D6D;" v-if="index === 0">Present</strong>
                <strong style="color :#6D6D6D;" v-if="index === 1">Late</strong>
                <strong style="color :#6D6D6D;" v-if="index === 2">Excuse Leave</strong>
                <strong style="color :#6D6D6D;" v-if="index === 3">Unexcuse Leave</strong>
                <strong style="color :#6D6D6D;" v-if="index === 4">Sick</strong>
              </div>
              <div class="right" style="margin-top:27px">
                <div>
                  {{ data }}
                </div>
              </div>
            </div>
            <v-progress-linear
              v-if="index === 0"
              style="
            border-radius: 8px;"
              color="#0177FB"
              :value="data"
              height="30"
            />
            <v-progress-linear
              v-if="index === 1"
              style="
            border-radius: 8px;"
              color="#40DCA7"
              :value="data"
              height="30"
            />
            <v-progress-linear
              v-if="index === 2"
              style="
            border-radius: 8px;"
              color="#FF9743"
              :value="data"
              height="30"
            />
            <v-progress-linear
              v-if="index === 3"
              style="
            border-radius: 8px;"
              color="rgb(255, 69, 96)"
              :value="data"
              height="30"
            />
            <v-progress-linear
              v-if="index === 4"
              style="
            border-radius: 8px;"
              color="rgb(119, 93, 208)"
              :value="data"
              height="30"
            />
          </div>
        </section>

        <div class="html2pdf__page-break" />

        <!-- pentagon chart -->
        <section class="chart-container" style="padding:40px;">
          <h4 style="color :#6D6D6D;margin-bottom:50px;">C.Pentagon Report</h4>
          <div v-if="form.pentagon.data.length >= 3">
            <apexchart type="radar" height="100%" width="100%" :options="chartOptionsPentagon" :series="seriesPentagon" />
          </div>
          <div v-if="form.pentagon.data.length <= 2">
            <template>
              <div class="succ">
                <div class="succ-content">
                  <svg-icon icon="ic-nodata-mini" class="succ-featured" width="130" height="100" />
                  <h1 class="succ-heading">{{ $t('content.chart_not_available') }}</h1>
                </div>
              </div>
            </template>
          </div>
        </section>

        <section class="line">
          <hr width="100%" style="margin-top:100px;" />
          <h4 style="color :#6D6D6D;margin-bottom:50px;margin-top:20px">D.Top 3 Course</h4>

          <div
            class="class-perform-rank"
            style="color :#6D6D6D;margin-bottom:20px;margin-top:20px"
            v-for="(data, index) in form.pentagon.topThree"
            :key="index"
          >
            <div class="row">
              <div class="left" style="margin-top:27px">
                <strong style="color :#6D6D6D;">{{ data.courseName }}</strong>
              </div>
              <div class="right" style="margin-top:27px">
                <strong style="color:#00bf63;">{{ data.score }} </strong>
              </div>
            </div>
          </div>
        </section>
      </section>
    </vue-html2pdf>
    <div class="d-flex justify-end align-center mt-5">
      <v-btn color="primary" class="btn-primary-custom mr-3" outlined @click="back">{{ $t('back') }}</v-btn>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTitle from '@/components/base/Title';
import apexchart from 'vue-apexcharts';
import FileViewer from '@/components/FileViewerErapor';
import VueHtml2pdf from 'vue-html2pdf';

export default {
  name: 'DetailAnaliticStudent',
  components: {
    BaseTitle,
    apexchart,
    FileViewer,
    VueHtml2pdf
    // NoData
  },
  sockets: {
    connect() {
      console.log('socket connected');
    },
    updateDetailAnalyticalStudent({ schoolId, analyticalStudentId }) {
      const currentschoolId = this.user.schoolId;
      const currentanalyticalStudentId = this.$route.params.idStudent;
      if (schoolId == currentschoolId && analyticalStudentId == currentanalyticalStudentId) {
        this.$store.dispatch('general/showSuccessNotification', { message: 'Update Analytic Student Detail' });
        setTimeout(() => {
          this.getData();
        }, 400);
      }
    }
  },
  computed: {
    ...mapGetters({
      classLevel: 'QuizTeacher/classLevel',
      user: 'Auth/user',
      nameCourse: 'CourseList/nameCourse'
    }),
    htmlToPdfOptions() {
      return {
        margin: 0,

        filename: 'pusing.pdf',

        image: {
          type: 'jpeg',
          quality: 0.98
        },

        enableLinks: true,

        html2canvas: {
          scale: 2,
          useCORS: true
        },

        jsPDF: {
          unit: 'in',
          format: 'a4',
          orientation: 'portrait'
        }
      };
    }
  },
  data: () => ({
    dataClass: '',
    listStudent: [],
    loadingLoad: false,
    loadingExport: false,
    titleData: '',
    search: '',
    form: {
      classroomName: '',
      fullName: '',
      identityNumber: '',
      schoolName: '',
      yearPeriode: '',
      classPerformance: {
        studentFrom: '',
        totalStudent: '',
        averageScore: '',
        categories: [],
        data: [],
        rank: []
      },
      attendance: {
        categories: [],
        data: [],
        totalSession: ''
      },
      pentagon: {
        categories: [],
        name: '',
        data: [],
        topThree: []
      }
    },
    seriesClassPerform: [],
    chartOptionsClassPerform: {},
    seriesAttendance: [],
    chartOptionsPentagon: {},
    seriesPentagon: [],
    dialogPreview: false,
    preview: {},
    chartOptionsAttendance: {}
  }),
  watch: {
    '$i18n.locale': {
      immediate: true,
      handler() {
        this.getData();
      }
    }
  },
  methods: {
    async downloadPdf() {
      this.$refs.html2Pdf.generatePdf();
    },

    async beforeDownload({ html2pdf, options, pdfContent }) {
      this.loadingExport = true;
      await html2pdf()
        .set(options)
        .from(pdfContent)
        .toPdf()
        .get('pdf')
        .then(pdf => {
          var blobURL = window.URL.createObjectURL(new Blob([pdf.output('blob')], { type: 'application/pdf' }));
          const fileList = {
            URL: 'school-3/user-12/69123669-97be-4565-87e2-7555e103587e_202106281607.pdf',
            extension: 'pdf',
            fileName: `analytical student`,
            fileUrl: blobURL,
            key: 'school-3/user-12/69123669-97be-4565-87e2-7555e103587e_202106281607.pdf',
            name: `analytical student.pdf`,
            size: '186 KB',
            dataUpload: pdf.output('blob')
          };
          this.dialogPreview = true;
          this.$set(this, 'preview', fileList);

          this.loadingExport = false;
        });
    },
    getData() {
      this.loadingLoad = true;
      this.$store
        .dispatch('Analytical/getChartResultStudentAnalitic', { id: this.$route.params.idResult, studentId: this.$route.params.idStudent })
        .then(res => {
          // class perform chart
          let seriesClassPerform = [
            {
              name: 'Score',
              data: res.classPerformance.data
            },
            {
              name: 'Rank',
              data: res.classPerformance.rank
            }
          ];
          let optionsClassPerform = {
            chart: {
              height: 350,
              type: 'line',
              dropShadow: {
                enabled: true,
                color: '#000',
                top: 18,
                left: 7,
                blur: 10,
                opacity: 0.2
              },
              toolbar: {
                show: false
              }
            },
            colors: ['#1A73E8', 'transparent'],
            dataLabels: {
              enabled: true
            },
            tooltip: {
              enabled: true,
              enabledOnSeries: undefined,
              shared: true,
              followCursor: false,
              intersect: false,
              inverseOrder: false,
              style: {
                fontSize: '12px'
              },
              custom: function({ series, dataPointIndex }) {
                return (
                  '<div class="arrow_box pa-2">' +
                  '<span style="font-weight: bold;">' +
                  res.classPerformance.categories[dataPointIndex] +
                  '</span></br>' +
                  '<v-divider class="mt-2 mb-2">' +
                  '<span>' +
                  'Score : ' +
                  '<span style="font-weight: bold;">' +
                  series[0][dataPointIndex] +
                  '</span>' +
                  '</span>' +
                  '</br>' +
                  '<span>' +
                  'Rank : ' +
                  '<span style="font-weight: bold;">' +
                  series[1][dataPointIndex] +
                  '</span>' +
                  '</span>' +
                  '</div>'
                );
              }
            },
            stroke: {
              curve: 'smooth'
            },
            grid: {
              borderColor: '#e7e7e7',
              row: {
                colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                opacity: 0.5
              }
            },
            markers: {
              size: 1
            },
            xaxis: {
              categories: res.classPerformance.categories,
              tooltip: {
                enabled: false
              }
            },
            yaxis: {
              title: {
                text: 'Score'
              }
            },
            legend: {
              show: false
            }
          };

          this.chartOptionsClassPerform = optionsClassPerform;
          this.seriesClassPerform = seriesClassPerform;

          // attendance chart
          this.seriesAttendance = res.attendance.data;
          const chartOptionsDonut = {
            chart: {
              type: 'donut'
            },
            labels: res.attendance.categories,
            plotOptions: {
              pie: {
                donut: {
                  labels: {
                    show: true,
                    name: {
                      offsetY: 10
                    },
                    value: {
                      fontSize: '20px',
                      fontWeight: 800,
                      show: true,
                      offsetY: 20
                    },
                    total: {
                      show: true,
                      showAlways: true,
                      ontSize: '20px',
                      fontWeight: 800,
                      label: res.attendance.totalSession + ' Session',
                      formatter: function() {
                        return '';
                      }
                    }
                  }
                }
              }
            },
            dataLabels: {
              style: {
                fontSize: '10px',
                fontFamily: 'Helvetica, Arial, sans-serif',
                fontWeight: 'bold',
                colors: ['rgb(0, 143, 251)', 'rgb(0, 227, 150)']
              },
              background: {
                enabled: true,
                foreColor: '#fff',
                padding: 4,
                borderRadius: 10,
                borderWidth: 1,
                borderColor: '#fff',
                opacity: 0.9
              }
            },
            responsive: [
              {
                breakpoint: 480,
                options: {
                  chart: {
                    width: 200
                  },
                  legend: {
                    position: 'bottom'
                  }
                }
              }
            ]
          };
          this.chartOptionsAttendance = chartOptionsDonut;

          // pentagon chart

          this.seriesPentagon = [
            {
              name: 'Scores',
              data: res.pentagon.data
            }
          ];
          this.chartOptionsPentagon = {
            chart: {
              height: 350,
              type: 'radar'
            },
            dataLabels: {
              enabled: true
            },
            plotOptions: {
              radar: {
                size: 140,
                polygons: {
                  strokeColors: '#e9e9e9',
                  fill: {
                    colors: ['#f8f8f8', '#fff']
                  }
                }
              }
            },
            colors: ['#FF4560'],
            markers: {
              size: 4,
              colors: ['#fff'],
              strokeColor: '#FF4560',
              strokeWidth: 2
            },
            tooltip: {
              y: {
                formatter: function(val) {
                  return val;
                }
              }
            },
            xaxis: {
              categories: res.pentagon.categories
            },
            yaxis: {
              tickAmount: 7,
              labels: {
                formatter: function(val, i) {
                  if (i % 2 === 0) {
                    return val;
                  } else {
                    return '';
                  }
                }
              }
            }
          };
          this.form = res;
        })
        .finally(() => (this.loadingLoad = false));
    },
    exportPDF() {
      this.loadingExport = true;
      this.$store
        .dispatch('Analytical/downloadStudent', { id: this.$route.params.idResult, studentId: this.$route.params.idStudent })
        .then(res => {
          var blobURL = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
          const fileList = {
            URL: 'school-3/user-12/69123669-97be-4565-87e2-7555e103587e_202106281607.pdf',
            extension: 'pdf',
            fileName: `rekap analytical student`,
            fileUrl: blobURL,
            key: 'school-3/user-12/69123669-97be-4565-87e2-7555e103587e_202106281607.pdf',
            name: `rekap analytical student.pdf`,
            size: '186 KB',
            dataUpload: res.data
          };
          this.dialogPreview = true;
          this.$set(this, 'preview', fileList);
        })
        .finally(() => (this.loadingExport = false));
    },
    hidePreview() {
      this.dialogPreview = null;
      this.$set(this, 'preview', {});
    },
    back() {
      this.$router.push({ name: 'viewResultStudent' });
    }
  },
  created() {
    this.getData();
    // this.getDataDetail();
  }
};
</script>

<style lang="scss" scoped>
.section-header {
  border-radius: 4px 4px 0 0;

  &.active {
    background: #00bf63;
    .student-title {
      color: #fff;
      font-size: 18px;
      font-weight: bold;
    }
  }

  &.disabled {
    background: #acacac;
    pointer-events: none;

    .student-title {
      color: #fff;
    }
  }
}
.body-content {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 12px;
  line-height: 14px;
  text-align: left;
}
.header-content {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 14px;
  line-height: 16px;
  width: 133px;
  text-align: left;
}
.text-dropdown {
  cursor: pointer;
  &-delete {
    color: red;
    cursor: pointer;
  }
}
.class-perform-rank {
  background-color: #b2ebd0;
  border-radius: 8px;
  height: 70px;
}
.from-student {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 12px;
  line-height: 22px;
  text-align: left;
}

.succ {
  min-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-family: Montserrat;
  font-weight: 500;

  &-content {
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 20px;
    font-size: 12px;
  }

  &-featured {
    width: 100%;
    margin-bottom: 30px;
  }

  &-heading {
    color: #6d6d6d;
    font-family: Montserrat;
    font-weight: bold;
    font-size: 16px;
  }
}

.pdf-content {
  width: 100%;
  background: #fff;
  div {
    color: #6d6d6d;
  }

  .chart-container {
    width: 100%;
    height: 320px;
    padding: 20px;
    pointer-events: none;
  }
  .line {
    color: #6d6d6d;
    -webkit-print-color-adjust: exact;
    width: 100%;
    margin-top: 15px;
    padding: 0px 40px 0px 40px;
    pointer-events: none;
  }
  .table-container {
    -webkit-print-color-adjust: exact;
    width: 100%;
    padding: 20px 20px 20px 40px;
    pointer-events: none;
  }
}
.row {
  display: flex;
  align-items: center;
}
.left {
  margin-left: 50px;
  margin-right: auto;
  margin-bottom: 10px;
}
.right {
  margin-left: auto;
  margin-right: 50px;
  margin-bottom: 10px;
}
</style>
